import { get, put } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadCheckList = (documentId, siteId) => get(`${url}/leasingDocument/${documentId}/${siteId}/checklist`);
const updateCheckList = (offerId, offerSiteId, folderId, folderSiteId, checklistList) =>
  put(`${url}/leasingDocument/checklist/update`, { offerId, offerSiteId, folderId, folderSiteId, checklistList });

const exp = {
  loadCheckList,
  updateCheckList
};
export default exp;
